import { Component, OnInit ,ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { CountryModel } from 'src/app/masters/country/country.model';
import { MasterService } from 'src/app/masters/master.service';
import { OrganismModel } from '../organisms/organism.model';
import { PartnersService } from '../partners.service';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import * as CommonConstants from '../../utils/common.constants';
import { AddLogsticsComponent } from './add-logistics/add-logistics.component';
import { PartnerSearchComponent } from '../partner-search/partner-search.component';
import { LoaderService } from 'src/app/common/loader.service';
import { SharedService } from 'src/app/utils/shared.service';

@Component({
  selector: 'app-logistics',
  templateUrl: './logistics.component.html',
  styleUrls: ['./logistics.component.scss']
})
export class LogisticsComponent implements OnInit {
  organisms: OrganismModel[];
  townList: any = [];
  countryList: any = [];
  columnDefs: any[];
  addLogistics;
  startIndex;
  rowsPerPage;
  totalRecords;
  paginationSize = CommonConstants.PAGINATION_SIZE;
  logisticsSearchForm: FormGroup;
  rowData: any[];
  toggleColumn = true;
  @ViewChild(PartnerSearchComponent,{static:true})   pSearch : PartnerSearchComponent;
  addressTypeList : any[];
  
  newLogistics: AddLogsticsComponent;
  priv_addLogi: boolean;
  @ViewChild(AddLogsticsComponent, { static: true }) set Content(newLogisticsRef) {
    this.newLogistics = newLogisticsRef;
  }
  constructor(public router: Router,private partnerService:PartnersService,private formBuilder: FormBuilder, 
    private masterService: MasterService, private loaderService: LoaderService,private sharedService:SharedService) {

    this.columnDefs = [
      // { headerName: 'Id', field: 'logistId'},
      { headerName: 'Name', field: 'compaVaNameEn'},
      { headerName: 'Organism', field: 'orgName'},
      { headerName: 'Work Phone', field: 'compaVaWorkPhone'},
      { headerName: 'Mobile Phone', field: 'compaVaMobilePhone1'},
      { headerName: 'Email', field: 'compaVaEmail'}       
    ];
    this.getFromGroup();  
   }

  ngOnInit() {
    this.priv_addLogi=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_LOGISTICS);
    this.pSearch.pSearch["active"]=true;
    this.pSearch.partnerType=CommonConstants.PARTNER_LOGISTICS_TYPE;
  }
  addNewLogistics() {
    this.router.navigate(['addLogistics']);
    this.newLogistics.addLogisticsTitle = true;
    this.newLogistics.editLogisticsTitle = false;
  }
  hideRightDiv() {
    this.addLogistics = false;
    this.toggleColumn = true;
  }
/**
    * Declare form group
    *  
    */
   private getFromGroup() {
    this.logisticsSearchForm = this.formBuilder.group({
      'orgsmId':  new FormControl(),
      'name': new FormControl(),
      'cotryId': new FormControl(),
      'townId' : new FormControl()
    })
    this.loadMasterData();
  }
  loadMasterData() {
    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
      this.searchLogistics();
    })
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });

  }
  searchLogistics() {
    //this.addLogistics = false;
    this.startIndex = 0;
    this.rowsPerPage = CommonConstants.PAGINATION_SIZE;
    //this.paginatedList();
    this.pSearch.pSearch['active']=this.pSearch.pSearch['active'] ? 'A' :'I';
    this.loaderService.display(true);
      this.partnerService.searchLogistics(this.pSearch.pSearch, this.startIndex).subscribe(response => {
        this.loaderService.display(false);
        response['result']=response['result'].map(item => ({...item,
          orgName: item.orgsmId ? this.organisms.find(obj => obj.orgsmId === item.orgsmId).compaVaNameEn : null }))
          this.rowData = response['result'];
      },
      error => {
        this.loaderService.display(false);
      })
    this.hideRightDiv();
  }

  paginatedList() {
    this.pSearch.pSearch['partnerType'] = 7;
    this.partnerService.searchLogistics(this.logisticsSearchForm.value, this.startIndex).subscribe(response => {
      let result = response['result'];
      this.rowData = result;
      this.totalRecords = result['totalRecords'];
    },
    error => {
      this.loaderService.display(false);
    })
  }

  paginate(event: any) {
    this.startIndex = event.first;
    this.rowsPerPage = event.rows;
    this.paginatedList();
  }
  reset(){
    this.logisticsSearchForm.reset();
    this.rowData =[];
    this.pSearch.pSearch={};
  }
 
  loadLogisticsById(event: any) {
    let logistics={
      "id":event.data.logistId
    }
    this.loaderService.display(true);
    this.partnerService.searchLogistics(logistics, this.startIndex).subscribe(response => {
      this.loaderService.display(false);
      this.newLogistics.hospDepartment.departmentList = [];
      this.newLogistics.hospAddress.addressList = [];
      this.newLogistics.hospContact.contactList=[];
      if (response['code'] == 'S0000') {
        let result = response['result'][0];
        this.newLogistics.logisticsForm.patchValue({
          logistId:result["logistId"],
      orgsmId:result["orgsmId"],
      compaVaNameEn:result["compaVaNameEn"],
      pacatId:result["pacatId"],
      pctypId:result["pctypId"],
      compaVaWorkPhone:result["compaVaWorkPhone"],
      compaVaWorkFax:result["compaVaWorkFax"],
      compaVaMobilePhone1:result["compaVaMobilePhone1"],
      compaVaMobilePhone2:result["compaVaMobilePhone2"],
      compaVaEmail:result["compaVaEmail"],
      compaVaHomepage:result["compaVaHomepage"],
      leforId:result["leforId"],
      compaNuNumberEmployees:result["compaNuNumberEmployees"],
      agmntId:result["agmntId"],
      certiId:result["certiId"],
      pagrpId:result["pagrpId"],
      staRecCode: result["staRecCode"] ==='A' ? true : false
        });

        result['addressList'] = result.addressList.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description : null,
          townName: item.townId ? this.townList.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countryList.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        })); 
         this.newLogistics.hospDepartment.departmentList = JSON.parse(JSON.stringify(result['departmentList']));
         this.sharedService.setOrganismDepartment(this.newLogistics.hospDepartment.departmentList);
        this.newLogistics.hospAddress.addressList = JSON.parse(JSON.stringify(result['addressList']));
        this.newLogistics.hospContact.employeeList = JSON.parse(JSON.stringify(result['employeeList']));
        this.newLogistics.phoneNos.forEach(phone => {
          phone.phone=phone.getInternationPhoneFormat(result[phone.type]);
      })
      }
    },
    error => {
      this.loaderService.display(false);
    })
  }
  onRowClicked(event: any) {
    this.addLogistics = true;
    this.toggleColumn = false;
    this.newLogistics.addLogisticsTitle = false;
    this.newLogistics.editLogisticsTitle = true;
     this.loadLogisticsById(event);
   }
}
